
import { useState, useRef, useCallback } from "react";

/* ─── CSS (injected once) ─── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');

:root {
  --color-primary:#6366F1; --color-primary-hover:#5558E3; --color-primary-active:#4F46E5;
  --color-secondary-purple:#A5B4FC;
  --color-success:#10B981; --color-success-hover:#059669; --color-success-light:#6EE7B7;
  --color-alert:#FB7185; --color-alert-hover:#F43F5E; --color-alert-dark:#E11D48;
  --color-warning:#F59E0B; --color-warning-hover:#D97706;
  --text-primary:#1E293B; --text-secondary:#64748B; --text-tertiary:#94A3B8;
  --bg-white:#FFFFFF; --bg-base:#F8FAFC;
  --bg-purple-subtle:#EEF2FF; --bg-purple-light:#E0E7FF;
  --bg-green-light:#ECFDF5; --bg-coral-light:#FFF1F2; --bg-amber-light:#FFFBEB;
  --border-default:#E2E8F0; --border-subtle:#F1F5F9; --border-strong:#CBD5E1;
  --shadow-sm:0px 1px 3px rgba(99,102,241,.08);
  --shadow-md:0px 4px 6px rgba(99,102,241,.1);
  --shadow-lg:0px 10px 25px rgba(99,102,241,.15);
  --shadow-purple:0px 2px 4px rgba(99,102,241,.2);
  --radius-sm:6px; --radius-md:8px; --radius-lg:12px; --radius-full:16px;
  --font:'Inter',sans-serif; --mono:'JetBrains Mono',monospace;
}
*{box-sizing:border-box;margin:0;padding:0}
.dp-root{font-family:var(--font);background:var(--bg-base);color:var(--text-primary);font-size:14px;line-height:1.5;-webkit-font-smoothing:antialiased;height:100vh;width:100%;max-width:100%;overflow:hidden;display:flex;flex-direction:column}

/* TOPBAR */
.dp-topbar{height:52px;background:var(--text-primary);display:flex;align-items:center;justify-content:space-between;padding:0 24px;box-shadow:var(--shadow-lg);position:relative;z-index:200;flex-shrink:0}
.dp-brand{font-size:13px;font-weight:700;color:#fff;letter-spacing:.12em;text-transform:uppercase;display:flex;align-items:center;gap:8px}
.dp-brand-dot{width:8px;height:8px;border-radius:50%;background:var(--color-primary)}
.dp-brand em{color:var(--color-secondary-purple);font-style:normal}
.dp-nav{display:flex;gap:2px}
.dp-ntab{font-size:12px;font-weight:500;padding:6px 14px;border-radius:var(--radius-md);color:rgba(255,255,255,.45);cursor:pointer;transition:all .15s;border:none;background:none;font-family:var(--font)}
.dp-ntab:hover{color:rgba(255,255,255,.8);background:rgba(255,255,255,.07)}
.dp-ntab.active{background:var(--color-primary);color:#fff;box-shadow:var(--shadow-purple)}
.dp-avatar{width:28px;height:28px;border-radius:50%;background:var(--bg-purple-light);color:var(--color-primary);font-size:10px;font-weight:700;display:flex;align-items:center;justify-content:center;border:2px solid var(--color-secondary-purple)}

/* APP */
.dp-app{display:flex;flex-direction:column;flex:1;overflow:hidden;min-width:0;width:100%}
.dp-screen{display:none;flex:1;overflow:hidden;flex-direction:column;min-width:0;width:100%}
.dp-screen.active{display:flex}

/* SHARED BTN */
.dp-btn{padding:8px 16px;border-radius:var(--radius-md);font-size:13px;font-weight:600;cursor:pointer;border:none;transition:all .15s;display:inline-flex;align-items:center;gap:6px;font-family:var(--font);white-space:nowrap}
.dp-btn-primary{background:var(--color-primary);color:#fff;box-shadow:var(--shadow-purple)}
.dp-btn-primary:hover{background:var(--color-primary-hover);transform:translateY(-1px);box-shadow:0 4px 8px rgba(99,102,241,.3)}
.dp-btn-secondary{background:var(--bg-white);color:var(--color-primary);border:1.5px solid var(--color-primary)}
.dp-btn-secondary:hover{background:var(--bg-purple-subtle)}
.dp-btn-sm{padding:6px 12px;font-size:12px}

/* CONFIG SCREEN */
.dp-cfg-header{background:var(--bg-white);border-bottom:1px solid var(--border-default);padding:14px 24px;display:flex;align-items:center;justify-content:space-between;flex-shrink:0;box-shadow:var(--shadow-sm)}
.dp-cfg-header h1{font-size:15px;font-weight:600;color:var(--text-primary)}
.dp-cfg-header p{font-size:11px;color:var(--text-tertiary);margin-top:2px}
.dp-cfg-body{display:flex;flex-direction:row;flex:1;min-height:0;overflow:hidden;width:100%}

/* estate panel */
.dp-estate{background:var(--bg-white);border-right:1px solid var(--border-default);display:flex;flex-direction:column;overflow:hidden;flex:0 0 340px;width:340px}
.dp-panel-top{padding:12px 16px;border-bottom:1px solid var(--border-default);flex-shrink:0}
.dp-panel-top-title{font-size:12px;font-weight:600;color:var(--text-primary);margin-bottom:8px}
.dp-searchbox{position:relative}
.dp-searchbox svg{position:absolute;left:10px;top:50%;transform:translateY(-50%);color:var(--text-tertiary);pointer-events:none}
.dp-searchbox input{width:100%;background:var(--bg-base);border:1px solid var(--border-default);border-radius:var(--radius-md);padding:8px 12px 8px 32px;font-size:12px;color:var(--text-primary);font-family:var(--font);outline:none;transition:all .15s}
.dp-searchbox input:focus{border-color:var(--color-primary);box-shadow:0 0 0 3px rgba(99,102,241,.1)}
.dp-searchbox input::placeholder{color:var(--text-tertiary)}
.dp-tree-wrap{flex:1;overflow-y:auto;padding:4px 0}

/* tree */
.dp-dom-block{border-bottom:1px solid var(--border-subtle)}
.dp-dom-row{display:flex;align-items:center;gap:6px;padding:8px 14px;cursor:pointer;user-select:none;transition:background .1s}
.dp-dom-row:hover{background:var(--bg-purple-subtle)}
.dp-chev{transition:transform .15s;color:var(--text-tertiary);flex-shrink:0}
.dp-chev.o{transform:rotate(90deg)}
.dp-dom-ic{width:22px;height:22px;border-radius:5px;background:var(--bg-purple-subtle);display:flex;align-items:center;justify-content:center;flex-shrink:0}
.dp-dom-name{font-size:12px;font-weight:600;color:var(--text-primary);flex:1;min-width:0}
.dp-dom-ct{font-size:10px;color:var(--text-tertiary);white-space:nowrap}
.dp-add-tag{font-size:9px;font-weight:700;padding:2px 7px;border-radius:var(--radius-full);cursor:pointer;border:1px solid;transition:all .12s;flex-shrink:0;font-family:var(--font);letter-spacing:.02em}
.dp-add-tag.d{background:var(--bg-purple-subtle);color:var(--color-primary);border-color:var(--color-secondary-purple)}
.dp-add-tag.d:hover,.dp-add-tag.d.on{background:var(--color-primary);color:#fff;border-color:var(--color-primary)}
.dp-add-tag.p{background:var(--bg-green-light);color:#065F46;border-color:var(--color-success-light)}
.dp-add-tag.p:hover,.dp-add-tag.p.on{background:var(--color-success);color:#fff;border-color:var(--color-success)}
.dp-add-tag.t{background:var(--bg-purple-subtle);color:var(--color-primary);border-color:var(--color-secondary-purple)}
.dp-add-tag.t:hover,.dp-add-tag.t.on{background:var(--color-primary);color:#fff;border-color:var(--color-primary)}
.dp-prods{display:none}.dp-prods.o{display:block}
.dp-prod-row{display:flex;align-items:center;gap:6px;padding:7px 14px 7px 28px;cursor:pointer;transition:background .1s;user-select:none}
.dp-prod-row:hover{background:var(--bg-purple-subtle)}
.dp-prod-ic{width:18px;height:18px;border-radius:4px;background:var(--bg-green-light);display:flex;align-items:center;justify-content:center;flex-shrink:0}
.dp-prod-name{font-size:11px;font-weight:500;color:var(--text-primary);flex:1;min-width:0}
.dp-prod-ct{font-size:10px;color:var(--text-tertiary)}
.dp-tbls{display:none}.dp-tbls.o{display:block}
.dp-tbl-row{display:flex;align-items:center;gap:6px;padding:5px 14px 5px 42px;cursor:pointer;transition:background .1s}
.dp-tbl-row:hover{background:var(--bg-purple-subtle)}
.dp-tbl-row.on .dp-tbl-name{color:var(--color-primary);font-weight:500}
.dp-tbl-name{font-size:10.5px;font-family:var(--mono);color:var(--text-secondary);flex:1;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}

/* middle */
.dp-cfg-mid{padding:16px;background:var(--bg-base);overflow-y:auto;overflow-x:hidden;display:flex;flex-direction:column;gap:10px;flex:1 1 0;min-width:0;width:0}
.dp-mid-label{font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.08em;color:var(--text-tertiary)}
.dp-empty-msg{background:var(--bg-white);border:1.5px dashed var(--border-default);border-radius:var(--radius-lg);padding:32px 20px;text-align:center;box-shadow:var(--shadow-sm)}
.dp-empty-msg p{font-size:12px;color:var(--text-tertiary);line-height:1.8}
.dp-sel-card{background:var(--bg-white);border:1px solid var(--border-default);border-radius:var(--radius-lg);box-shadow:var(--shadow-sm);width:100%;box-sizing:border-box}
.dp-sel-card.tc{border-top:3px solid var(--color-primary)}
.dp-sel-card.pc{border-top:3px solid var(--color-success)}
.dp-sel-card.dc{border-top:3px solid var(--color-warning)}
.dp-sc-top{display:flex;align-items:center;gap:8px;padding:10px 12px}
.dp-sc-pill{font-size:9px;font-weight:700;padding:2px 7px;border-radius:var(--radius-full);text-transform:uppercase;letter-spacing:.05em;flex-shrink:0}
.dp-sc-pill.t{background:var(--bg-purple-subtle);color:var(--color-primary)}
.dp-sc-pill.p{background:var(--bg-green-light);color:#065F46}
.dp-sc-pill.d{background:var(--bg-amber-light);color:#78350F}
.dp-sc-name{font-size:11px;font-weight:500;flex:1;min-width:0;font-family:var(--mono);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:var(--text-primary)}
.dp-sc-rm{width:20px;height:20px;border:none;background:none;cursor:pointer;color:var(--text-tertiary);border-radius:var(--radius-sm);display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:all .12s}
.dp-sc-rm:hover{background:var(--bg-coral-light);color:var(--color-alert)}
.dp-sc-meta{padding:0 12px 8px;font-size:10px;color:var(--text-tertiary)}
.dp-feats{padding:0 12px 10px;display:flex;flex-wrap:wrap;gap:4px}
.dp-fc{font-size:10px;padding:3px 9px;border-radius:var(--radius-full);cursor:pointer;border:1px solid var(--border-default);color:var(--text-secondary);background:var(--bg-base);transition:all .12s;user-select:none;font-weight:500}
.dp-fc.on{background:var(--bg-purple-subtle);border-color:var(--color-secondary-purple);color:var(--color-primary)}
.dp-fc:hover{border-color:var(--color-primary);color:var(--color-primary)}
.dp-lin-preview{border-top:1px solid var(--border-subtle);padding:10px 12px;background:var(--bg-base)}
.dp-lin-lbl{font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:.08em;color:var(--text-tertiary);margin-bottom:7px}
.dp-lin-chain{display:flex;flex-direction:column;gap:4px}
.dp-ln{display:flex;align-items:center;gap:6px;font-size:10px;font-family:var(--mono);color:var(--text-secondary)}
.dp-ln.anch{color:var(--color-primary);font-weight:600}
.dp-ln-dot{width:5px;height:5px;border-radius:50%;flex-shrink:0}
.dp-ln-dot.u{background:var(--color-secondary-purple)}
.dp-ln-dot.a{background:var(--color-primary)}
.dp-ln-dot.d{background:var(--color-success)}
.dp-ln-tag{font-size:8px;font-weight:700;padding:1px 5px;border-radius:3px;margin-left:auto;flex-shrink:0}
.dp-ln-tag.u{background:var(--bg-purple-subtle);color:var(--color-primary)}
.dp-ln-tag.a{background:var(--color-primary);color:#fff}
.dp-ln-tag.d{background:var(--bg-green-light);color:#065F46}
.dp-ln-sep{height:1px;background:var(--border-default);margin:3px 0}

/* right lineage panel */
.dp-lin-panel{background:var(--bg-white);border-left:1px solid var(--border-default);display:flex;flex-direction:column;overflow:hidden;flex:0 0 272px;width:272px}
.dp-lp-body{flex:1;overflow-y:auto;padding:14px}
.dp-lp-empty{text-align:center;padding:40px 14px}
.dp-lp-empty p{font-size:11px;color:var(--text-tertiary);line-height:1.8}
.dp-flow-block{margin-bottom:16px}
.dp-flow-anchor-lbl{font-size:10px;font-family:var(--mono);font-weight:600;color:var(--text-primary);margin-bottom:8px;padding:6px 8px;background:var(--bg-purple-subtle);border-radius:var(--radius-sm);border-left:3px solid var(--color-primary)}
.dp-flow-dir{font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:.08em;margin-bottom:5px;display:flex;align-items:center;gap:4px}
.dp-flow-dir.u{color:var(--color-primary)}.dp-flow-dir.d{color:#065F46}
.dp-flow-nodes{display:flex;align-items:center;flex-wrap:wrap;gap:4px;margin-bottom:8px}
.dp-fn{font-size:10px;font-family:var(--mono);padding:4px 9px;border-radius:var(--radius-md);border:1px solid}
.dp-fn.u{background:var(--bg-purple-subtle);border-color:var(--color-secondary-purple);color:var(--color-primary)}
.dp-fn.a{background:var(--color-primary);color:#fff;font-weight:600}
.dp-fn.d{background:var(--bg-green-light);border-color:var(--color-success-light);color:#065F46}
.dp-fn.r{background:#F5F3FF;border-color:#C4B5FD;color:#5B21B6}
.dp-farr{font-size:10px;color:var(--text-tertiary)}
.dp-flow-sep{height:1px;background:var(--border-subtle);margin:12px 0}
.dp-cfg-footer{background:var(--bg-white);border-top:1px solid var(--border-default);padding:12px 24px;display:flex;align-items:center;justify-content:space-between;flex-shrink:0}
.dp-ft-note{font-size:11px;color:var(--text-tertiary);display:flex;align-items:center;gap:5px}

/* DASHBOARD */
.dp-dash-wrap{display:flex;flex:1;overflow:hidden}
.dp-dash-main{flex:1;overflow-y:auto;display:flex;flex-direction:column;min-width:0}
.dp-dash-hdr{background:var(--bg-white);border-bottom:1px solid var(--border-default);padding:12px 24px;display:flex;align-items:center;justify-content:space-between;flex-shrink:0;box-shadow:var(--shadow-sm)}
.dp-dash-hdr h1{font-size:15px;font-weight:700;color:var(--text-primary)}
.dp-dash-hdr p{font-size:11px;color:var(--text-tertiary);margin-top:2px}
.dp-schips{display:flex;gap:4px;flex-wrap:wrap;align-items:center}
.dp-schip{font-size:10px;font-weight:600;padding:3px 9px;border-radius:var(--radius-full);display:flex;align-items:center;gap:3px;border:1px solid}
.dp-schip.t{background:var(--bg-purple-subtle);color:var(--color-primary);border-color:var(--color-secondary-purple)}
.dp-schip.p{background:var(--bg-green-light);color:#065F46;border-color:var(--color-success-light)}
.dp-schip.d{background:var(--bg-amber-light);color:#78350F;border-color:#FCD34D}
.dp-schip.gray{background:var(--bg-base);color:var(--text-secondary);border-color:var(--border-default)}

/* score strip */
.dp-score-strip{display:grid;grid-template-columns:repeat(7,minmax(0,1fr));background:var(--bg-white);border-bottom:1px solid var(--border-default);flex-shrink:0}
.dp-sc-cell{padding:11px 8px;border-right:1px solid var(--border-subtle);text-align:center;cursor:pointer;transition:background .12s;position:relative}
.dp-sc-cell:last-child{border-right:none}
.dp-sc-cell:hover{background:var(--bg-purple-subtle)}
.dp-sc-cell.flagged::after{content:'';position:absolute;bottom:0;left:25%;right:25%;height:2px;border-radius:2px 2px 0 0;background:var(--color-primary)}
.dp-sc-lbl{font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.07em;color:var(--text-tertiary);margin-bottom:3px}
.dp-sc-val{font-size:18px;font-weight:700;color:var(--text-primary);line-height:1;font-family:var(--mono)}
.dp-sc-tag{display:inline-flex;align-items:center;gap:2px;font-size:9px;font-weight:600;margin-top:4px;padding:2px 7px;border-radius:var(--radius-full)}
.dp-sc-tag.r{background:var(--bg-coral-light);color:var(--color-alert-dark);border:1px solid var(--color-alert)}
.dp-sc-tag.a{background:var(--bg-amber-light);color:#78350F;border:1px solid var(--color-warning)}
.dp-sc-tag.g{background:var(--bg-green-light);color:#065F46;border:1px solid var(--color-success)}

/* triage */
.dp-triage{padding:16px 24px}
.dp-section-lbl{font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.1em;color:var(--text-tertiary);margin-bottom:12px;display:flex;align-items:center;gap:8px}
.dp-section-lbl::after{content:'';flex:1;height:1px;background:var(--border-default)}
.dp-signals{display:flex;flex-direction:column;gap:6px}
.dp-signal{display:flex;align-items:stretch;border-radius:var(--radius-lg);border:1px solid var(--border-default);background:var(--bg-white);cursor:pointer;transition:all .15s;overflow:hidden;box-shadow:var(--shadow-sm)}
.dp-signal:hover{border-color:var(--color-secondary-purple);background:var(--bg-purple-subtle);box-shadow:var(--shadow-md);transform:translateX(2px)}
.dp-signal.active{border-color:var(--color-primary);background:var(--bg-purple-subtle);box-shadow:var(--shadow-md)}
.dp-signal.crit .dp-sac{background:var(--color-alert-dark)}
.dp-signal.warn .dp-sac{background:var(--color-warning)}
.dp-signal.ok .dp-sac{background:var(--color-success)}
.dp-sac{width:4px;flex-shrink:0}
.dp-sig-body{display:flex;align-items:center;gap:12px;padding:11px 14px;flex:1;min-width:0}
.dp-sig-dot{width:8px;height:8px;border-radius:50%;flex-shrink:0}
.dp-signal.crit .dp-sig-dot{background:var(--color-alert-dark)}
.dp-signal.warn .dp-sig-dot{background:var(--color-warning)}
.dp-signal.ok .dp-sig-dot{background:var(--color-success)}
.dp-sig-info{flex:1;min-width:0}
.dp-sig-name{font-size:12px;font-weight:600;color:var(--text-primary)}
.dp-sig-detail{font-size:10px;color:var(--text-secondary);margin-top:2px;font-family:var(--mono)}
.dp-sig-meta{display:flex;align-items:center;gap:8px;flex-shrink:0}
.dp-sig-chip{font-size:9px;font-family:var(--mono);padding:3px 7px;border-radius:var(--radius-sm);background:var(--bg-base);color:var(--text-secondary);border:1px solid var(--border-default);white-space:nowrap;font-weight:500}
.dp-sig-age{font-size:9px;color:var(--text-tertiary);white-space:nowrap}
.dp-sig-arr{font-size:14px;color:var(--text-tertiary);flex-shrink:0;padding-right:4px;transition:color .12s}
.dp-signal:hover .dp-sig-arr,.dp-signal.active .dp-sig-arr{color:var(--color-primary)}

/* summary panels */
.dp-sum-panels{padding:0 24px 16px;display:flex;flex-direction:column;gap:6px}
.dp-sum-lbl{font-size:10px;color:var(--text-tertiary);font-weight:600;text-transform:uppercase;letter-spacing:.08em;padding:4px 24px 8px;flex-shrink:0}
.dp-spanel{background:var(--bg-white);border:1px solid var(--border-default);border-radius:var(--radius-lg);overflow:hidden;box-shadow:var(--shadow-sm)}
.dp-sp-hdr{display:flex;align-items:center;justify-content:space-between;padding:11px 14px;cursor:pointer;user-select:none;transition:background .1s}
.dp-sp-hdr:hover{background:var(--bg-purple-subtle)}
.dp-sp-title{display:flex;align-items:center;gap:8px;font-size:13px;font-weight:600;color:var(--text-primary)}
.dp-sp-ic{width:26px;height:26px;border-radius:var(--radius-md);background:var(--bg-purple-subtle);display:flex;align-items:center;justify-content:center;flex-shrink:0}
.dp-sp-right{display:flex;align-items:center;gap:7px}
.dp-sp-badge{font-size:9px;font-weight:700;padding:3px 8px;border-radius:var(--radius-full)}
.dp-sp-badge.r{background:var(--bg-coral-light);color:var(--color-alert-dark);border:1px solid var(--color-alert)}
.dp-sp-badge.a{background:var(--bg-amber-light);color:#78350F;border:1px solid var(--color-warning)}
.dp-sp-badge.g{background:var(--bg-green-light);color:#065F46;border:1px solid var(--color-success)}
.dp-chev-ic{transition:transform .18s;color:var(--text-tertiary)}
.dp-chev-ic.o{transform:rotate(180deg)}
.dp-sp-body{display:none;border-top:1px solid var(--border-subtle);padding:14px}
.dp-sp-body.o{display:block}
.dp-mini-tbl{width:100%;border-collapse:collapse;font-size:11px;table-layout:fixed}
.dp-mini-tbl th{font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:var(--text-tertiary);padding:5px 8px;border-bottom:1.5px solid var(--border-default);text-align:left}
.dp-mini-tbl td{padding:8px 8px;border-bottom:1px solid var(--border-subtle);vertical-align:middle}
.dp-mini-tbl tbody tr{cursor:pointer;transition:background .1s}
.dp-mini-tbl tbody tr:hover{background:var(--bg-purple-subtle)}
.dp-mini-tbl tr:last-child td{border-bottom:none}
.dp-mn{font-size:10.5px;font-family:var(--mono);font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.dp-ms{font-size:9px;color:var(--text-tertiary)}
.dp-bar-c{display:flex;align-items:center;gap:6px}
.dp-bar-bg{flex:1;height:4px;border-radius:2px;background:var(--border-subtle)}
.dp-bar-fill{height:4px;border-radius:2px}
.dp-bar-fill.h{background:var(--color-success)}.dp-bar-fill.m{background:var(--color-warning)}.dp-bar-fill.l{background:var(--color-alert-dark)}
.dp-dqpill{font-size:10px;font-weight:700;font-family:var(--mono);padding:2px 7px;border-radius:var(--radius-full)}
.dp-dqpill.h{background:var(--bg-green-light);color:#065F46}.dp-dqpill.m{background:var(--bg-amber-light);color:#78350F}.dp-dqpill.l{background:var(--bg-coral-light);color:var(--color-alert-dark)}
.dp-dt-pill{font-size:8px;font-weight:700;padding:2px 6px;border-radius:3px;letter-spacing:.03em}
.dp-dt-pill.u{background:var(--bg-purple-subtle);color:var(--color-primary)}
.dp-dt-pill.d{background:var(--bg-green-light);color:#065F46}
.dp-dt-pill.a{background:var(--color-primary);color:#fff}
.dp-focus-link{font-size:10px;color:var(--color-primary);cursor:pointer;font-weight:600;padding:3px 8px;border-radius:var(--radius-sm);background:var(--bg-purple-subtle);border:1px solid var(--color-secondary-purple);white-space:nowrap;transition:all .12s}
.dp-focus-link:hover{background:var(--color-primary);color:#fff}

/* RECOMMENDATION */
.dp-rec-wrap{padding:0 24px 20px}
.dp-rec-card{background:var(--bg-white);border:1px solid var(--border-default);border-radius:var(--radius-lg);overflow:hidden;box-shadow:var(--shadow-sm)}
.dp-rec-hd{background:linear-gradient(135deg,var(--bg-purple-subtle) 0%,var(--bg-purple-light) 100%);border-bottom:1px solid var(--color-secondary-purple);padding:14px 16px;display:flex;align-items:center;justify-content:space-between;gap:10px}
.dp-rec-hd-left{display:flex;align-items:center;gap:10px}
.dp-rec-hd-ic{width:34px;height:34px;border-radius:var(--radius-md);background:var(--color-primary);display:flex;align-items:center;justify-content:center;flex-shrink:0;box-shadow:var(--shadow-purple)}
.dp-rec-hd-title{font-size:13px;font-weight:700;color:var(--text-primary)}
.dp-rec-hd-sub{font-size:10px;color:var(--text-secondary);margin-top:2px}
.dp-rec-gen-btn{font-size:11px;font-weight:600;padding:7px 14px;border-radius:var(--radius-md);background:var(--color-primary);color:#fff;border:none;cursor:pointer;font-family:var(--font);display:flex;align-items:center;gap:5px;transition:all .15s;flex-shrink:0;box-shadow:var(--shadow-purple)}
.dp-rec-gen-btn:hover{background:var(--color-primary-hover);transform:translateY(-1px)}
.dp-rec-gen-btn:disabled{background:var(--border-strong);color:var(--text-tertiary);cursor:not-allowed;transform:none;box-shadow:none}
.dp-rec-body{padding:14px 16px;min-height:80px}
.dp-rec-placeholder{display:flex;align-items:center;justify-content:center;flex-direction:column;gap:8px;padding:24px;text-align:center}
.dp-rec-placeholder p{font-size:12px;color:var(--text-tertiary);line-height:1.7}
.dp-rec-loading{display:flex;align-items:center;gap:10px;padding:20px;color:var(--text-secondary);font-size:12px}
.dp-rec-dots{display:flex;gap:5px}
.dp-rec-dot{width:7px;height:7px;border-radius:50%;background:var(--color-secondary-purple);animation:dp-bounce .9s infinite}
.dp-rec-dot:nth-child(2){animation-delay:.2s}
.dp-rec-dot:nth-child(3){animation-delay:.4s}
@keyframes dp-bounce{0%,80%,100%{transform:translateY(0)}40%{transform:translateY(-8px)}}
.dp-rec-stream{font-size:12px;color:var(--text-primary);line-height:1.8;padding:4px 0;white-space:pre-wrap}
.dp-rec-ft{border-top:1px solid var(--border-subtle);padding:10px 16px;display:flex;align-items:center;justify-content:space-between}
.dp-rec-note{font-size:10px;color:var(--text-secondary);display:flex;align-items:center;gap:4px}
.dp-dl-btn{display:flex;align-items:center;gap:5px;font-size:11px;font-weight:600;padding:7px 14px;border-radius:var(--radius-md);background:var(--color-primary);color:#fff;border:none;cursor:pointer;font-family:var(--font);transition:all .15s;box-shadow:var(--shadow-purple)}
.dp-dl-btn:hover{background:var(--color-primary-hover)}

/* FOCUS DRAWER */
.dp-focus-drawer{width:0;overflow:hidden;background:var(--bg-white);border-left:1px solid var(--border-default);display:flex;flex-direction:column;transition:width .22s cubic-bezier(.4,0,.2,1);flex-shrink:0;box-shadow:-4px 0 20px rgba(99,102,241,.06)}
.dp-focus-drawer.open{width:384px}
.dp-fd-hdr{padding:14px 16px;border-bottom:1px solid var(--border-default);display:flex;align-items:flex-start;justify-content:space-between;gap:8px;background:var(--color-primary);flex-shrink:0}
.dp-fd-hdr h2{font-size:12px;font-weight:600;color:#fff;font-family:var(--mono);margin-bottom:3px}
.dp-fd-hdr p{font-size:10px;color:rgba(255,255,255,.65)}
.dp-fd-close{width:24px;height:24px;border:1.5px solid rgba(255,255,255,.3);background:rgba(255,255,255,.1);cursor:pointer;color:#fff;border-radius:var(--radius-sm);display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:all .1s}
.dp-fd-close:hover{background:rgba(255,255,255,.25)}
.dp-fd-body{flex:1;overflow-y:auto;padding:14px}
.dp-fd-sec{margin-bottom:16px}
.dp-fd-lbl{font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:.1em;color:var(--text-tertiary);margin-bottom:9px;display:flex;align-items:center;gap:6px}
.dp-fd-lbl::after{content:'';flex:1;height:1px;background:var(--border-default)}
.dp-ring-row{display:flex;align-items:center;gap:14px;margin-bottom:12px}
.dp-ring{position:relative;width:58px;height:58px;flex-shrink:0}
.dp-ring svg{transform:rotate(-90deg)}
.dp-ring-val{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:13px;font-weight:700;font-family:var(--mono);color:var(--text-primary)}
.dp-ring-info-name{font-size:12px;font-weight:600;color:var(--text-primary);margin-bottom:3px;font-family:var(--mono)}
.dp-ring-info-meta{font-size:10px;color:var(--text-tertiary);line-height:1.6}
.dp-spark-row{display:flex;align-items:flex-end;gap:3px;height:40px;margin-bottom:4px}
.dp-spark-bar{flex:1;border-radius:2px 2px 0 0;min-height:3px}
.dp-spark-labs{display:flex;justify-content:space-between;font-size:8px;color:var(--text-tertiary);font-family:var(--mono)}
.dp-rule-row{display:flex;align-items:center;gap:8px;padding:7px 0;border-bottom:1px solid var(--border-subtle)}
.dp-rule-row:last-child{border-bottom:none}
.dp-rule-dot{width:6px;height:6px;border-radius:50%;flex-shrink:0}
.dp-rule-dot.p{background:var(--color-success)}.dp-rule-dot.f{background:var(--color-alert-dark)}.dp-rule-dot.w{background:var(--color-warning)}
.dp-rule-name{font-size:11px;color:var(--text-primary);flex:1}
.dp-rule-val{font-size:10px;font-family:var(--mono);font-weight:600}
.dp-rule-val.p{color:#065F46}.dp-rule-val.f{color:var(--color-alert-dark)}.dp-rule-val.w{color:#78350F}
.dp-lin-r{display:flex;align-items:center;gap:5px;padding:5px 0;border-bottom:1px solid var(--border-subtle)}
.dp-lin-r:last-child{border-bottom:none}
.dp-lfn{font-size:10px;font-family:var(--mono);padding:3px 8px;border-radius:var(--radius-sm);border:1px solid;white-space:nowrap;max-width:150px;overflow:hidden;text-overflow:ellipsis}
.dp-lfn.u{background:var(--bg-purple-subtle);border-color:var(--color-secondary-purple);color:var(--color-primary)}
.dp-lfn.a{background:var(--color-primary);color:#fff;font-weight:600}
.dp-lfn.d{background:var(--bg-green-light);border-color:var(--color-success-light);color:#065F46}
.dp-lfn.r{background:#F5F3FF;border-color:#C4B5FD;color:#5B21B6}
.dp-larr{font-size:10px;color:var(--text-tertiary);flex-shrink:0}
.dp-cost-kv{display:flex;justify-content:space-between;align-items:center;padding:6px 0;border-bottom:1px solid var(--border-subtle);font-size:11px}
.dp-cost-kv:last-child{border-bottom:none}
.dp-ck{color:var(--text-secondary)}.dp-cv{font-family:var(--mono);font-weight:600;color:var(--text-primary)}
.dp-cv.hi{color:var(--color-alert-dark)}
.dp-inc-item{display:flex;align-items:flex-start;gap:7px;padding:7px 0;border-bottom:1px solid var(--border-subtle)}
.dp-inc-item:last-child{border-bottom:none}
.dp-inc-dot{width:6px;height:6px;border-radius:50%;flex-shrink:0;margin-top:4px}
.dp-inc-dot.c{background:var(--color-alert-dark)}.dp-inc-dot.w{background:var(--color-warning)}
.dp-inc-nm{font-size:11px;font-weight:600;color:var(--text-primary)}
.dp-inc-mt{font-size:9px;color:var(--text-tertiary);margin-top:2px}
.dp-inc-ag{font-size:9px;color:var(--text-tertiary);white-space:nowrap;margin-left:auto;flex-shrink:0}
`;

/* ─── ICONS ─── */
const ChevRight = ({cls=""}) => <svg style={{display:'inline-block',verticalAlign:'middle',flexShrink:0}} className={cls} width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="9 18 15 12 9 6"/></svg>;
const ChevDown = ({cls=""}) => <svg style={{display:'inline-block',verticalAlign:'middle',flexShrink:0}} className={cls} width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="6 9 12 15 18 9"/></svg>;
const DbIc = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#6366F1" strokeWidth="2" strokeLinecap="round"><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/></svg>;
const ProdIc = () => <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2" strokeLinecap="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/></svg>;
const TblIc = () => <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="9" x2="9" y2="21"/></svg>;
const SearchIc = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>;
const CheckIc = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>;
const CloseIc = ({w=12,h=12}) => <svg width={w} height={h} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const InfoIc = ({w=12,h=12}) => <svg width={w} height={h} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>;
const BoltIc = ({w=12,h=12,color="currentColor"}) => <svg width={w} height={h} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>;
const GearIc = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="3"/><path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"/></svg>;
const DlIc = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>;
const AiIc = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round"><path d="M12 2a7 7 0 017 7c0 3.5-2.5 6-4 7.5V18a1 1 0 01-1 1h-4a1 1 0 01-1-1v-1.5C7.5 15 5 12.5 5 9a7 7 0 017-7z"/><line x1="9" y1="21" x2="15" y2="21"/><line x1="9.5" y1="17" x2="14.5" y2="17"/></svg>;
const ArrowDn = () => <svg width="7" height="7" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>;
const ArrowUp = () => <svg width="7" height="7" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="5 12 12 5 19 12"/></svg>;
const ClockIc = () => <svg width="7" height="7" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>;
const OkIc = () => <svg width="7" height="7" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>;
const WaveIc = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#6366F1" strokeWidth="1.8" strokeLinecap="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>;
const DollarIc = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#6366F1" strokeWidth="1.8" strokeLinecap="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>;
const TrendIc = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#6366F1" strokeWidth="1.8" strokeLinecap="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>;
const LayersIc = () => <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#CBD5E1" strokeWidth="1.5" strokeLinecap="round" style={{marginBottom:10}}><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>;
const CodeIc = () => <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#CBD5E1" strokeWidth="1.5" strokeLinecap="round" style={{marginBottom:10}}><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>;

/* ─── DATA ─── */
const TDATA = {
  'snk_order_fulfillment_fact':{product:'Order Fulfillment',domain:'E2E-Supplychain',dq:68,dqC:'m',dqTrend:[82,79,75,72,68],cost:390,mat:3,matL:'Optimised',usage:719,depth:'anchor',incidents:[{s:'w',n:'Freshness breach — last loaded 52h ago',m:'Freshness rule · anchor',a:'6d ago'}],rules:[{s:'p',n:'Completeness check',v:'Pass'},{s:'p',n:'Uniqueness — order_id',v:'Pass'},{s:'w',n:'Freshness — 24h SLA',v:'52h late'},{s:'p',n:'Referential integrity',v:'Pass'}],upstream:[{n:'snk_erp_sales_raw',c:'u'},{n:'snk_order_fulfillment_staging',c:'u'}],downstream:[{n:'pbi_order_fill_rate',c:'r'},{n:'pbi_supply_chain_kpi',c:'r'}]},
  'snk_erp_sales_raw':{product:'Order Fulfillment',domain:'E2E-Supplychain',dq:0,dqC:'l',dqTrend:[88,84,62,21,0],cost:510,mat:1,matL:'Defined',usage:0,depth:'↑ upstream d2',incidents:[{s:'c',n:'Null check failure — 42 affected rows',m:'DQ rule · upstream d2',a:'2d ago'},{s:'c',n:'Pipeline cost anomaly — $510 with DQ 0',m:'Cost rule · over budget',a:'This week'}],rules:[{s:'f',n:'Null check — sale_amount',v:'Fail · 42 rows'},{s:'f',n:'Freshness — 12h SLA',v:'Fail · 31h late'},{s:'p',n:'Row count baseline',v:'Pass'},{s:'w',n:'Schema validation',v:'1 warning'}],upstream:[{n:'src_sap_sd_orders',c:'u'}],downstream:[{n:'snk_order_fulfillment_staging',c:'d'},{n:'snk_order_fulfillment_fact',c:'d'}]},
  'snk_inventory_edf_eu':{product:'Inventory',domain:'E2E-Supplychain',dq:0,dqC:'l',dqTrend:[95,90,52,18,0],cost:130,mat:1,matL:'Defined',usage:36,depth:'anchor',incidents:[{s:'c',n:'Row count anomaly — −18k rows',m:'DQ rule · anchor',a:'3d ago'}],rules:[{s:'f',n:'Row count baseline — ±5% tolerance',v:'Fail · −18k rows'},{s:'f',n:'Freshness — 24h SLA',v:'Fail · 72h late'},{s:'p',n:'Schema validation',v:'Pass'},{s:'p',n:'Uniqueness — product_id',v:'Pass'}],upstream:[{n:'src_edf_eu_raw_feed',c:'u'}],downstream:[{n:'snk_inventory_edf_eu_mart',c:'d'},{n:'pbi_inventory_health_dash',c:'r'}]},
  'snk_inventory_edf_eu_mart':{product:'Inventory',domain:'E2E-Supplychain',dq:91,dqC:'h',dqTrend:[88,90,91,90,91],cost:0,mat:2,matL:'Managed',usage:108,depth:'↓ downstream d1',incidents:[],rules:[{s:'p',n:'Completeness check',v:'Pass'},{s:'p',n:'Freshness — 4h SLA',v:'Pass · 2h'},{s:'p',n:'Row count baseline',v:'Pass'},{s:'w',n:'Source dependency freshness',v:'Warning — source at 0'}],upstream:[{n:'snk_inventory_edf_eu',c:'u'}],downstream:[{n:'pbi_inventory_health_dash',c:'r'}]},
  'snk_order_fulfillment_staging':{product:'Order Fulfillment',domain:'E2E-Supplychain',dq:21,dqC:'l',dqTrend:[72,66,45,30,21],cost:210,mat:2,matL:'Managed',usage:301,depth:'↑ upstream d1',incidents:[{s:'w',n:'Schema drift — 2 columns changed',m:'Metadata · upstream d1',a:'5d ago'}],rules:[{s:'w',n:'Schema validation',v:'2 columns changed'},{s:'f',n:'Null check — order_line_id',v:'Fail · propagated'},{s:'p',n:'Row count baseline',v:'Pass'},{s:'p',n:'Uniqueness',v:'Pass'}],upstream:[{n:'snk_erp_sales_raw',c:'u'}],downstream:[{n:'snk_order_fulfillment_fact',c:'d'}]}
};

const DOMAINS = [
  {name:'E2E-Supplychain',ct:'4 products · 28 tbl',open:true,products:[
    {name:'Order Fulfillment',ct:'8 tbl',open:true,tables:['snk_order_fulfillment_fact','snk_order_fulfillment_staging','snk_order_fulfillment_errors']},
    {name:'Inventory',ct:'6 tbl',open:true,tables:['snk_inventory_edf_eu','snk_inventory_edf_eu_mart']},
    {name:'Demand Planning',ct:'5 tbl',open:false,tables:['snk_demand_planning_actuals']},
    {name:'Physical Logistics',ct:'9 tbl',open:false,tables:['snk_logistics_movements_eu']},
  ]},
  {name:'Sales',ct:'2 products · 12 tbl',open:false,products:[
    {name:'Field Sales Execution',ct:'7 tbl',open:false,tables:['snk_field_sales_roamler']},
  ]},
  {name:'Finance',ct:'3 products · 18 tbl',open:false,products:[
    {name:'P&L Reporting',ct:'8 tbl',open:false,tables:['fin_pl_actuals_monthly']},
  ]},
];

/* ─── FEATURE CHIP ─── */
function FeatChip({label}) {
  const [on, setOn] = useState(['DQ','Incidents','Cost','Usage'].includes(label));
  return <div className={`dp-fc${on?' on':''}`} onClick={()=>setOn(v=>!v)}>{label}</div>;
}

/* ─── SELECTION CARD ─── */
function SelCard({s, onRemove, tdata}) {
  const pc = s.type==='domain'?'dc':s.type==='product'?'pc':'tc';
  const pl = s.type==='domain'?'d':s.type==='product'?'p':'t';
  const meta = s.type==='table'?(s.product+' · '+s.domain):(s.domain?s.domain+' · ':'')+s.meta;
  const td = s.type==='table'?tdata[s.name]:null;
  return (
    <div className={`dp-sel-card ${pc}`}>
      <div className="dp-sc-top">
        <span className={`dp-sc-pill ${pl}`}>{s.type}</span>
        <div className="dp-sc-name">{s.name}</div>
        <button className="dp-sc-rm" onClick={()=>onRemove(s.type,s.name)}><CloseIc w={11} h={11}/></button>
      </div>
      <div className="dp-sc-meta">{meta}</div>
      <div className="dp-feats">
        {['DQ','Incidents','Cost','Usage','Maturity','TAT'].map(f=><FeatChip key={f} label={f}/>)}
      </div>
      {td && (
        <div className="dp-lin-preview">
          <div className="dp-lin-lbl">Upstream &amp; downstream</div>
          <div className="dp-lin-chain">
            {td.upstream.map(u=><div key={u.n} className="dp-ln"><div className="dp-ln-dot u"/>{u.n}<span className="dp-ln-tag u">↑</span></div>)}
            <div className="dp-ln-sep"/>
            <div className="dp-ln anch"><div className="dp-ln-dot a"/>{s.name}<span className="dp-ln-tag a">anchor</span></div>
            <div className="dp-ln-sep"/>
            {td.downstream.map(d=><div key={d.n} className="dp-ln"><div className="dp-ln-dot d"/>{d.n}<span className="dp-ln-tag d">↓</span></div>)}
          </div>
        </div>
      )}
    </div>
  );
}

/* ─── SUMMARY PANEL ─── */
function SumPanel({title, badge, badgeCls, icon, children}) {
  const [open, setOpen] = useState(false);
  return (
    <div className="dp-spanel">
      <div className="dp-sp-hdr" onClick={()=>setOpen(v=>!v)}>
        <div className="dp-sp-title"><div className="dp-sp-ic">{icon}</div>{title}</div>
        <div className="dp-sp-right">
          <span className={`dp-sp-badge ${badgeCls}`}>{badge}</span>
          <ChevDown cls={`dp-chev-ic${open?' o':''}`}/>
        </div>
      </div>
      <div className={`dp-sp-body${open?' o':''}`}>{children}</div>
    </div>
  );
}

/* ═══ MAIN APP ═══ */
export default function DataPulse() {
  const [screen, setScreen] = useState('config'); // 'config' | 'dash'
  const [sels, setSels] = useState([]);
  const [focusedTable, setFocusedTable] = useState(null);
  const [activeSignal, setActiveSignal] = useState(null);
  const [domainState, setDomainState] = useState(()=>DOMAINS.map(d=>({open:d.open,products:d.products.map(p=>({open:p.open}))})));
  const [tblOn, setTblOn] = useState({});
  const [tagOn, setTagOn] = useState({});
  const [searchQ, setSearchQ] = useState('');
  const [recState, setRecState] = useState('idle'); // idle | loading | done | error
  const [recText, setRecText] = useState('');
  const recTextRef = useRef('');

  // toggle domain open
  const togDom = (di) => setDomainState(prev=>prev.map((d,i)=>i===di?{...d,open:!d.open}:d));
  const togProd = (di,pi) => setDomainState(prev=>prev.map((d,i)=>i===di?{...d,products:d.products.map((p,j)=>j===pi?{...p,open:!p.open}:p)}:d));

  const addSel = (type, name, domain, meta) => {
    const key = `${type}::${name}`;
    if (tagOn[key]) {
      setSels(prev=>prev.filter(s=>!(s.type===type&&s.name===name)));
      setTagOn(prev=>({...prev,[key]:false}));
    } else {
      setSels(prev=>[...prev,{type,name,domain,meta}]);
      setTagOn(prev=>({...prev,[key]:true}));
    }
  };

  const addTbl = (tblName, product, domain) => {
    const key = `table::${tblName}`;
    if (tblOn[tblName]) {
      setSels(prev=>prev.filter(s=>!(s.type==='table'&&s.name===tblName)));
      setTblOn(prev=>({...prev,[tblName]:false}));
    } else {
      setSels(prev=>[...prev,{type:'table',name:tblName,product,domain}]);
      setTblOn(prev=>({...prev,[tblName]:true}));
    }
  };

  const removeSel = (type, name) => {
    setSels(prev=>prev.filter(s=>!(s.type===type&&s.name===name)));
    if(type==='table') setTblOn(prev=>({...prev,[name]:false}));
    else setTagOn(prev=>({...prev,[`${type}::${name}`]:false}));
  };

  const focusTable = (name) => { setFocusedTable(name); setActiveSignal(name); };
  const closeDrawer = () => { setFocusedTable(null); setActiveSignal(null); };

  const goDash = () => setScreen('dash');
  const goConfig = () => { setScreen('config'); closeDrawer(); };

  // filter tree
  const q = searchQ.toLowerCase();
  const domainVisible = (d) => !q || d.name.toLowerCase().includes(q) || d.products.some(p=>p.name.toLowerCase().includes(q)||p.tables.some(t=>t.toLowerCase().includes(q)));
  const prodVisible = (d, p) => !q || p.name.toLowerCase().includes(q) || d.name.toLowerCase().includes(q) || p.tables.some(t=>t.toLowerCase().includes(q));
  const tblVisible = (d, p, t) => !q || t.toLowerCase().includes(q) || p.name.toLowerCase().includes(q) || d.name.toLowerCase().includes(q);

  // Generate AI rec
  const generateRec = async () => {
    setRecState('loading');
    setRecText('');
    recTextRef.current = '';
    const signals = [
      {table:'snk_erp_sales_raw',issue:'DQ score 0 — null check failure on 42 rows, freshness breach 31h, cost $510/week with no usable output, maturity L1',severity:'critical'},
      {table:'snk_inventory_edf_eu',issue:'DQ score 0 — row count anomaly −18k rows unresolved 3 days, freshness breach 72h, anchor table for inventory mart',severity:'critical'},
      {table:'snk_order_fulfillment_staging',issue:'Schema drift — 2 columns changed, DQ score 21, may break downstream fact table transforms',severity:'warning'},
      {table:'snk_order_fulfillment_fact',issue:'Freshness breach 52h, DQ score 68 (below threshold 70), anchor table driving order fill rate reports',severity:'warning'},
      {table:'snk_inventory_edf_eu_mart',issue:'Healthy — DQ score 91, serving downstream reports normally, but source table has DQ 0',severity:'info'}
    ];
    const prompt = `You are a data governance advisor for Mars Snacking's Data Pulse platform.\n\nHere are the current data quality signals for the user's tracked tables:\n${signals.map(s=>`- ${s.table} (${s.severity}): ${s.issue}`).join('\n')}\n\nOverall scores: DQ avg 43 (below threshold 70), 4 open incidents, TAT 2.4d (threshold 2d), total cost $1.2k/week (over budget), maturity avg L2.1.\n\nProvide 4 specific, actionable recommendations prioritised by urgency. For each:\n1. State what to do (be specific — name the table, the rule, the action)\n2. State why (business impact, downstream risk, or cost implication)\n3. State who should act (data steward, DE, data owner)\n\nFormat as numbered recommendations. Be direct and technical. Do not use generic advice. Focus on what will have the most impact this week.`;
    try {
      const response = await fetch('https://api.anthropic.com/v1/messages',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({model:'claude-sonnet-4-20250514',max_tokens:1000,stream:true,messages:[{role:'user',content:prompt}]})
      });
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';
      while(true){
        const {done,value} = await reader.read();
        if(done) break;
        buffer += decoder.decode(value,{stream:true});
        const lines = buffer.split('\n');
        buffer = lines.pop();
        for(const line of lines){
          if(line.startsWith('data: ')){
            const data = line.slice(6);
            if(data==='[DONE]') continue;
            try{
              const parsed = JSON.parse(data);
              if(parsed.type==='content_block_delta'&&parsed.delta?.text){
                recTextRef.current += parsed.delta.text;
                setRecText(recTextRef.current);
              }
            }catch(e){}
          }
        }
      }
      setRecState('done');
    } catch(err) {
      setRecState('error');
    }
  };

  const downloadRec = () => {
    if(!recTextRef.current) return;
    const date = new Date().toISOString().split('T')[0];
    const content = `DATA PULSE — MyPulse Recommendation\nGenerated: ${date}\n\n${recTextRef.current}`;
    const blob = new Blob([content],{type:'text/plain'});
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `mypulse-recommendation-${date}.txt`;
    a.click();
  };

  // Focus drawer content
  const td = focusedTable ? TDATA[focusedTable] : null;
  const drawerContent = td ? (() => {
    const col = td.dqC==='h'?'#10B981':td.dqC==='m'?'#F59E0B':'#E11D48';
    const circ = 2*Math.PI*22;
    const dash = (td.dq/100)*circ;
    return (
      <>
        <div className="dp-fd-sec">
          <div className="dp-fd-lbl">DQ score</div>
          <div className="dp-ring-row">
            <div className="dp-ring">
              <svg width="58" height="58" viewBox="0 0 58 58">
                <circle cx="29" cy="29" r="22" fill="none" stroke="var(--border-default)" strokeWidth="5"/>
                <circle cx="29" cy="29" r="22" fill="none" stroke={col} strokeWidth="5" strokeDasharray={`${dash} ${circ}`} strokeLinecap="round"/>
              </svg>
              <div className="dp-ring-val">{td.dq}</div>
            </div>
            <div>
              <div className="dp-ring-info-name">{focusedTable}</div>
              <div className="dp-ring-info-meta">{td.product}<br/>Maturity: {td.matL} · Cost: ${td.cost}<br/>Usage: {td.usage} hits/7d</div>
            </div>
          </div>
          <div className="dp-fd-lbl" style={{marginBottom:6}}>DQ trend — last 5 periods</div>
          <div className="dp-spark-row">
            {td.dqTrend.map((v,i)=>{
              const h=Math.max(4,Math.round(v/100*36));
              const bc=v>=70?'#10B981':v>=40?'#F59E0B':'#E11D48';
              const op=i===td.dqTrend.length-1?1:.4;
              return <div key={i} className="dp-spark-bar" style={{height:h,background:bc,opacity:op}}/>;
            })}
          </div>
          <div className="dp-spark-labs"><span>−4wk</span><span>−3wk</span><span>−2wk</span><span>−1wk</span><span>Now</span></div>
        </div>
        <div className="dp-fd-sec">
          <div className="dp-fd-lbl">DQ rules</div>
          {td.rules.map((r,i)=><div key={i} className="dp-rule-row"><div className={`dp-rule-dot ${r.s}`}/><div className="dp-rule-name">{r.n}</div><span className={`dp-rule-val ${r.s}`}>{r.v}</span></div>)}
        </div>
        <div className="dp-fd-sec">
          <div className="dp-fd-lbl">Open incidents</div>
          {td.incidents.length===0?<div style={{fontSize:11,color:'var(--text-tertiary)',padding:'8px 0'}}>No open incidents</div>:
            td.incidents.map((inc,i)=><div key={i} className="dp-inc-item"><div className={`dp-inc-dot ${inc.s==='c'?'c':'w'}`}/><div style={{flex:1}}><div className="dp-inc-nm">{inc.n}</div><div className="dp-inc-mt">{inc.m}</div></div><div className="dp-inc-ag">{inc.a}</div></div>)
          }
        </div>
        <div className="dp-fd-sec">
          <div className="dp-fd-lbl">Lineage</div>
          {td.upstream.length>0 && <>
            <div style={{fontSize:9,fontWeight:700,textTransform:'uppercase',letterSpacing:'.08em',color:'var(--color-primary)',marginBottom:5}}>Upstream</div>
            {[...td.upstream].reverse().map(u=><div key={u.n} className="dp-lin-r"><div className="dp-lfn u">{u.n}</div><span className="dp-larr">→</span><div className="dp-lfn a">{focusedTable}</div></div>)}
          </>}
          {td.downstream.length>0 && <>
            <div style={{fontSize:9,fontWeight:700,textTransform:'uppercase',letterSpacing:'.08em',color:'#065F46',marginBottom:5,marginTop:10}}>Downstream</div>
            {td.downstream.map(d=><div key={d.n} className="dp-lin-r"><div className="dp-lfn a">{focusedTable}</div><span className="dp-larr">→</span><div className={`dp-lfn ${d.n.startsWith('pbi')?'r':'d'}`}>{d.n}</div></div>)}
          </>}
        </div>
        <div className="dp-fd-sec">
          <div className="dp-fd-lbl">Cost &amp; usage</div>
          <div className="dp-cost-kv"><span className="dp-ck">Cost this week</span><span className={`dp-cv${td.cost>300?' hi':''}`}>${td.cost}</span></div>
          <div className="dp-cost-kv"><span className="dp-ck">DBU hours</span><span className="dp-cv">{(td.cost/120).toFixed(1)}</span></div>
          <div className="dp-cost-kv"><span className="dp-ck">Query hits (7d)</span><span className="dp-cv">{td.usage}</span></div>
          <div className="dp-cost-kv"><span className="dp-ck">Maturity level</span><span className="dp-cv">L{td.mat} — {td.matL}</span></div>
        </div>
      </>
    );
  })() : null;

  return (
    <>
      <style>{CSS}</style>
      <div className="dp-root">
        {/* TOPBAR */}
        

        <div className="dp-app">

          {/* ═══ CONFIG SCREEN ═══ */}
          <div className={`dp-screen${screen==='config'?' active':''}`}>
            <div className="dp-cfg-header">
              <div>
                <h1>Configure my dashboard</h1>
                <p>Browse the full data estate and select domains, products, or individual tables. Lineage chains resolve automatically.</p>
              </div>
              <div style={{display:'flex',gap:8}}>
                <button className="dp-btn dp-btn-secondary dp-btn-sm" onClick={goDash}>Preview</button>
                <button className="dp-btn dp-btn-primary dp-btn-sm" onClick={goDash}><CheckIc/>Save &amp; view</button>
              </div>
            </div>

            <div className="dp-cfg-body">
              {/* ESTATE TREE */}
              <div className="dp-estate">
                <div className="dp-panel-top">
                  <div className="dp-panel-top-title">Data estate</div>
                  <div className="dp-searchbox">
                    <SearchIc/>
                    <input placeholder="Search domains, products, tables…" value={searchQ} onChange={e=>setSearchQ(e.target.value)}/>
                  </div>
                </div>
                <div className="dp-tree-wrap">
                  {DOMAINS.map((dom,di)=>{
                    if(!domainVisible(dom)) return null;
                    const ds = domainState[di];
                    const domKey = `domain::${dom.name}`;
                    return (
                      <div key={dom.name} className="dp-dom-block">
                        <div className="dp-dom-row" onClick={()=>togDom(di)}>
                          <ChevRight cls={`dp-chev${ds.open?' o':''}`}/>
                          <div className="dp-dom-ic"><DbIc/></div>
                          <div className="dp-dom-name">{dom.name}</div>
                          <div className="dp-dom-ct">{dom.ct}</div>
                          <span className={`dp-add-tag d${tagOn[domKey]?' on':''}`} onClick={e=>{e.stopPropagation();addSel('domain',dom.name,'',dom.ct);}}>+Domain</span>
                        </div>
                        <div className={`dp-prods${ds.open?' o':''}`}>
                          {dom.products.map((prod,pi)=>{
                            if(!prodVisible(dom,prod)) return null;
                            const ps = ds.products[pi];
                            const prodKey = `product::${prod.name}`;
                            return (
                              <div key={prod.name}>
                                <div className="dp-prod-row" onClick={()=>togProd(di,pi)}>
                                  <ChevRight cls={`dp-chev${ps.open?' o':''}`}/>
                                  <div className="dp-prod-ic"><ProdIc/></div>
                                  <div className="dp-prod-name">{prod.name}</div>
                                  <div className="dp-prod-ct">{prod.ct}</div>
                                  <span className={`dp-add-tag p${tagOn[prodKey]?' on':''}`} onClick={e=>{e.stopPropagation();addSel('product',prod.name,dom.name,prod.ct);}}>+Product</span>
                                </div>
                                <div className={`dp-tbls${ps.open?' o':''}`}>
                                  {prod.tables.map(tbl=>{
                                    if(!tblVisible(dom,prod,tbl)) return null;
                                    return (
                                      <div key={tbl} className={`dp-tbl-row${tblOn[tbl]?' on':''}`} onClick={()=>addTbl(tbl,prod.name,dom.name)}>
                                        <TblIc/>
                                        <div className="dp-tbl-name">{tbl}</div>
                                        <span className={`dp-add-tag t${tblOn[tbl]?' on':''}`} onClick={e=>{e.stopPropagation();addTbl(tbl,prod.name,dom.name);}}>{tblOn[tbl]?'−':'+'}</span>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* MIDDLE */}
              <div className="dp-cfg-mid">
                <div className="dp-mid-label">My selections — <span>{sels.length}</span> items</div>
                {sels.length===0 && (
                  <div className="dp-empty-msg">
                    <p>Nothing selected yet.<br/>Pick domains, products, or tables from the left.<br/>Upstream &amp; downstream chains appear here.</p>
                  </div>
                )}
                {sels.map((s,i)=><SelCard key={i} s={s} onRemove={removeSel} tdata={TDATA}/>)}
              </div>

              {/* RIGHT LINEAGE */}
              <div className="dp-lin-panel">
                <div className="dp-panel-top">
                  <div className="dp-panel-top-title">Lineage preview</div>
                  <div style={{fontSize:10,color:'var(--text-tertiary)',marginTop:2}}>Full upstream &amp; downstream chains for selected tables</div>
                </div>
                <div className="dp-lp-body">
                  {sels.filter(s=>s.type==='table'&&TDATA[s.name]).length===0 ? (
                    <div className="dp-lp-empty">
                      <p>Select tables to see<br/>their lineage chains here.</p>
                    </div>
                  ) : sels.filter(s=>s.type==='table'&&TDATA[s.name]).map(s=>{
                    const td2 = TDATA[s.name];
                    return (
                      <div key={s.name} className="dp-flow-block">
                        <div className="dp-flow-anchor-lbl">{s.name}</div>
                        {td2.upstream.length>0 && <>
                          <div className="dp-flow-dir u">
                            <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/></svg>
                            Upstream
                          </div>
                          <div className="dp-flow-nodes">
                            {[...td2.upstream].reverse().map(u=><><div key={u.n} className="dp-fn u">{u.n}</div><span className="dp-farr">→</span></>)}
                            <div className="dp-fn a">{s.name}</div>
                          </div>
                        </>}
                        {td2.downstream.length>0 && <>
                          <div className="dp-flow-dir d" style={{marginTop:6}}>
                            <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>
                            Downstream
                          </div>
                          <div className="dp-flow-nodes">
                            <div className="dp-fn a">{s.name}</div>
                            {td2.downstream.map(d=><><span className="dp-farr">→</span><div key={d.n} className={`dp-fn ${d.n.startsWith('pbi')?'r':'d'}`}>{d.n}</div></>)}
                          </div>
                        </>}
                        <div className="dp-flow-sep"/>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className="dp-cfg-footer">
              <div className="dp-ft-note"><InfoIc/>Personal view — other users are not affected</div>
              <button className="dp-btn dp-btn-primary dp-btn-sm" onClick={goDash}><CheckIc/>Save &amp; view my dashboard</button>
            </div>
          </div>

          {/* ═══ DASHBOARD SCREEN ═══ */}
          <div className={`dp-screen${screen==='dash'?' active':''}`}>
            <div className="dp-dash-wrap">
              <div className="dp-dash-main">

                {/* HEADER */}
                <div className="dp-dash-hdr">
                  <div><h1>MyPulse</h1><p>Triage view · click any signal or score to inspect the table · scoped to your selections + full lineage</p></div>
                  <div style={{display:'flex',alignItems:'center',gap:8}}>
                    <div className="dp-schips">
                      {sels.length===0
                        ? <span className="dp-schip gray">Demo scope</span>
                        : sels.map((s,i)=><span key={i} className={`dp-schip ${s.type.charAt(0)}`}>{s.name}</span>)
                      }
                    </div>
                    <button className="dp-btn dp-btn-secondary dp-btn-sm" onClick={goConfig}><GearIc/>Edit scope</button>
                  </div>
                </div>

                {/* SCORE STRIP */}
                <div className="dp-score-strip">
                  <div className="dp-sc-cell flagged" onClick={()=>focusTable('snk_order_fulfillment_fact')}>
                    <div className="dp-sc-lbl">DQ score</div><div className="dp-sc-val">43</div>
                    <div className="dp-sc-tag r"><ArrowDn/>Below 70</div>
                  </div>
                  <div className="dp-sc-cell flagged" onClick={()=>focusTable('snk_order_fulfillment_fact')}>
                    <div className="dp-sc-lbl">TAT score</div><div className="dp-sc-val">2.4d</div>
                    <div className="dp-sc-tag a"><ClockIc/>Threshold 2d</div>
                  </div>
                  <div className="dp-sc-cell flagged" onClick={()=>focusTable('snk_inventory_edf_eu')}>
                    <div className="dp-sc-lbl">Incidents</div><div className="dp-sc-val">4</div>
                    <div className="dp-sc-tag r"><ArrowUp/>+2 this week</div>
                  </div>
                  <div className="dp-sc-cell flagged" onClick={()=>focusTable('snk_erp_sales_raw')}>
                    <div className="dp-sc-lbl">Maturity</div><div className="dp-sc-val">2.1</div>
                    <div className="dp-sc-tag a">Level 2 of 4</div>
                  </div>
                  <div className="dp-sc-cell">
                    <div className="dp-sc-lbl">MTDA</div><div className="dp-sc-val">68%</div>
                    <div className="dp-sc-tag g"><OkIc/>Above threshold</div>
                  </div>
                  <div className="dp-sc-cell flagged" onClick={()=>focusTable('snk_erp_sales_raw')}>
                    <div className="dp-sc-lbl">Total cost</div><div className="dp-sc-val">$1.2k</div>
                    <div className="dp-sc-tag r"><ArrowUp/>Over budget</div>
                  </div>
                  <div className="dp-sc-cell flagged" onClick={()=>focusTable('snk_order_fulfillment_fact')}>
                    <div className="dp-sc-lbl">Usage</div><div className="dp-sc-val">1,052</div>
                    <div className="dp-sc-tag a"><ArrowDn/>Below target</div>
                  </div>
                </div>

                {/* TRIAGE SIGNALS */}
                <div className="dp-triage">
                  <div className="dp-section-lbl">Act on these now — 6 signals</div>
                  <div className="dp-signals">
                    {[
                      {sev:'crit',name:'Null check failure — DQ score dropped to 0',detail:'42 affected rows · upstream of order fulfillment anchor',chip:'snk_erp_sales_raw',age:'2d ago',tbl:'snk_erp_sales_raw'},
                      {sev:'crit',name:'Row count anomaly — −18k rows, unresolved 3 days',detail:'DQ score 0 · anchor table · EDF EU source suspect',chip:'snk_inventory_edf_eu',age:'3d ago',tbl:'snk_inventory_edf_eu'},
                      {sev:'warn',name:'Schema drift detected — 2 columns changed',detail:'May break downstream snk_order_fulfillment_fact transforms',chip:'snk_order_fulfillment_staging',age:'5d ago',tbl:'snk_order_fulfillment_staging'},
                      {sev:'warn',name:'Freshness breach — last loaded 52 hours ago',detail:'DQ score 68 · TAT threshold exceeded · anchor table',chip:'snk_order_fulfillment_fact',age:'6d ago',tbl:'snk_order_fulfillment_fact'},
                      {sev:'warn',name:'Cost over budget — $510 spend with DQ score 0',detail:'Highest cost table · compute may be wasted on broken pipeline',chip:'snk_erp_sales_raw',age:'This week',tbl:'snk_erp_sales_raw'},
                      {sev:'ok',name:'Downstream mart healthy despite source issues',detail:'DQ score 91 · serving pbi_inventory_health_dash normally',chip:'snk_inventory_edf_eu_mart',age:'Current',tbl:'snk_inventory_edf_eu_mart'},
                    ].map((sig,i)=>(
                      <div key={i} className={`dp-signal ${sig.sev}${activeSignal===sig.tbl?' active':''}`} onClick={()=>focusTable(sig.tbl)}>
                        <div className="dp-sac"/>
                        <div className="dp-sig-body">
                          <div className="dp-sig-dot"/>
                          <div className="dp-sig-info">
                            <div className="dp-sig-name">{sig.name}</div>
                            <div className="dp-sig-detail">{sig.detail}</div>
                          </div>
                          <div className="dp-sig-meta">
                            <span className="dp-sig-chip">{sig.chip}</span>
                            <span className="dp-sig-age">{sig.age}</span>
                          </div>
                          <span className="dp-sig-arr">›</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* SUMMARY PANELS */}
                <div className="dp-sum-lbl">Summary panels — expand for full coverage</div>
                <div className="dp-sum-panels">
                  <SumPanel title="DQ scores — all tables in scope" badge="3 below threshold" badgeCls="r" icon={<WaveIc/>}>
                    <table className="dp-mini-tbl">
                      <thead><tr><th style={{width:'44%'}}>Table</th><th style={{width:'14%'}}>Depth</th><th style={{width:'28%'}}>DQ score</th><th style={{width:'14%'}}></th></tr></thead>
                      <tbody>
                        {[
                          {tbl:'snk_order_fulfillment_fact',sub:'Order Fulfillment',depth:'a',dq:68,c:'m'},
                          {tbl:'snk_order_fulfillment_staging',sub:'',depth:'u',dq:21,c:'l'},
                          {tbl:'snk_erp_sales_raw',sub:'',depth:'u',dq:0,c:'l'},
                          {tbl:'snk_inventory_edf_eu',sub:'Inventory',depth:'a',dq:0,c:'l'},
                          {tbl:'snk_inventory_edf_eu_mart',sub:'',depth:'d',dq:91,c:'h'},
                        ].map(row=>(
                          <tr key={row.tbl} onClick={()=>focusTable(row.tbl)}>
                            <td><div className="dp-mn">{row.tbl}</div>{row.sub&&<div className="dp-ms">{row.sub}</div>}</td>
                            <td><span className={`dp-dt-pill ${row.depth}`}>{row.depth==='a'?'anchor':row.depth==='u'?'↑ d1':'↓ d1'}</span></td>
                            <td><div className="dp-bar-c"><div className="dp-bar-bg"><div className={`dp-bar-fill ${row.c}`} style={{width:`${Math.max(1,row.dq)}%`}}/></div><span className={`dp-dqpill ${row.c}`}>{row.dq}</span></div></td>
                            <td><span className="dp-focus-link">Focus</span></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </SumPanel>

                  <SumPanel title="Cost — all tables in scope" badge="2 over budget" badgeCls="a" icon={<DollarIc/>}>
                    <table className="dp-mini-tbl">
                      <thead><tr><th style={{width:'44%'}}>Table</th><th style={{width:'14%'}}>Depth</th><th style={{width:'20%',textAlign:'right'}}>Cost 7d</th><th style={{width:'22%'}}></th></tr></thead>
                      <tbody>
                        {[
                          {tbl:'snk_erp_sales_raw',depth:'u',cost:'$510',hi:true},
                          {tbl:'snk_order_fulfillment_fact',depth:'a',cost:'$390',hi:true},
                          {tbl:'snk_order_fulfillment_staging',depth:'u',cost:'$210',hi:false},
                          {tbl:'snk_inventory_edf_eu',depth:'a',cost:'$130',hi:false},
                        ].map(row=>(
                          <tr key={row.tbl} onClick={()=>focusTable(row.tbl)}>
                            <td><div className="dp-mn">{row.tbl}</div></td>
                            <td><span className={`dp-dt-pill ${row.depth}`}>{row.depth==='a'?'anchor':row.depth==='u'?'↑ d1':'↓ d1'}</span></td>
                            <td style={{textAlign:'right',fontFamily:'var(--mono)',fontWeight:700,color:row.hi?'var(--color-alert-dark)':'var(--text-primary)'}}>{row.cost}</td>
                            <td style={{textAlign:'right'}}><span className="dp-focus-link">Focus</span></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </SumPanel>

                  <SumPanel title="Maturity — all tables in scope" badge="Avg 2.1 / 4" badgeCls="a" icon={<TrendIc/>}>
                    <table className="dp-mini-tbl">
                      <thead><tr><th style={{width:'52%'}}>Table</th><th style={{width:'34%'}}>Maturity</th><th style={{width:'14%'}}></th></tr></thead>
                      <tbody>
                        {[
                          {tbl:'snk_order_fulfillment_fact',pct:75,c:'h',lbl:'L3'},
                          {tbl:'snk_inventory_edf_eu_mart',pct:50,c:'m',lbl:'L2'},
                          {tbl:'snk_inventory_edf_eu',pct:25,c:'l',lbl:'L1'},
                          {tbl:'snk_erp_sales_raw',pct:25,c:'l',lbl:'L1'},
                        ].map(row=>(
                          <tr key={row.tbl} onClick={()=>focusTable(row.tbl)}>
                            <td><div className="dp-mn">{row.tbl}</div></td>
                            <td><div className="dp-bar-c"><div className="dp-bar-bg"><div className={`dp-bar-fill ${row.c}`} style={{width:`${row.pct}%`}}/></div><span style={{fontSize:10,fontFamily:'var(--mono)',fontWeight:700}}>{row.lbl}</span></div></td>
                            <td><span className="dp-focus-link">Focus</span></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </SumPanel>
                </div>

                {/* RECOMMENDATION */}
                <div className="dp-rec-wrap">
                  <div className="dp-rec-card">
                    <div className="dp-rec-hd">
                      <div className="dp-rec-hd-left">
                        <div className="dp-rec-hd-ic"><AiIc/></div>
                        <div>
                          <div className="dp-rec-hd-title">AI Recommendation</div>
                          <div className="dp-rec-hd-sub">What should you do to improve or sustain your data health? Powered by Claude.</div>
                        </div>
                      </div>
                      <button className="dp-rec-gen-btn" disabled={recState==='loading'} onClick={generateRec}>
                        <BoltIc w={12} h={12}/>
                        {recState==='idle'?'Generate':recState==='loading'?'Generating…':'Regenerate'}
                      </button>
                    </div>
                    <div className="dp-rec-body">
                      {recState==='idle' && (
                        <div className="dp-rec-placeholder">
                          <BoltIc w={28} h={28} color="#CBD5E1"/>
                          <p>Click <strong>Generate</strong> to get AI-powered recommendations<br/>based on your current signals and scope.</p>
                        </div>
                      )}
                      {recState==='loading' && (
                        <div className="dp-rec-loading">
                          <div className="dp-rec-dots">
                            <div className="dp-rec-dot"/><div className="dp-rec-dot"/><div className="dp-rec-dot"/>
                          </div>
                          <span>Analysing signals across your scope…</span>
                        </div>
                      )}
                      {(recState==='done'||recState==='loading') && recText && (
                        <div className="dp-rec-stream">{recText}</div>
                      )}
                      {recState==='error' && (
                        <div className="dp-rec-loading" style={{color:'var(--color-alert-dark)'}}>
                          <InfoIc w={14} h={14}/>Unable to generate. Check API connectivity and try again.
                        </div>
                      )}
                    </div>
                    <div className="dp-rec-ft">
                      <div className="dp-rec-note"><InfoIc/>Powered by Claude · analysis based on signals in your current scope</div>
                      {recState==='done' && <button className="dp-dl-btn" onClick={downloadRec}><DlIc/>Download report</button>}
                    </div>
                  </div>
                </div>

              </div>

              {/* FOCUS DRAWER */}
              <div className={`dp-focus-drawer${focusedTable?' open':''}`}>
                <div className="dp-fd-hdr">
                  <div>
                    <h2>{focusedTable||'—'}</h2>
                    <p>{td?`${td.product} · ${td.domain} · ${td.depth}`:'—'}</p>
                  </div>
                  <button className="dp-fd-close" onClick={closeDrawer}><CloseIc/></button>
                </div>
                <div className="dp-fd-body">{drawerContent}</div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  );
}